import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/documentation/roles')({
  component: () => <Navigate replace search to="/bo/documentation/roles" />,
})
